// export this package's api
import Align from './Align';

export default Align;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_rc-align@2.4.3@rc-align/es/index.js
// module id = null
// module chunks = 